export default "__VITE_ASSET__CgyFQQnA__"